import { AlertTriangle, Hand, Lock, MessageSquareText } from "lucide-react";
import { ROLE_COLORS, roleOf } from "@/lib/roles";

const ORDER = ["fields", "relay", "cover", "backup", "hold"];

export const PlayBadge = ({ play }) =>
  play.customized ? (
    <span className="badge-coach shrink-0" data-testid="coach-version-badge">Coach's version</span>
  ) : (
    <span className="badge-review shrink-0" data-testid="needs-review-badge">Default · needs coach review</span>
  );

const Shell = ({ children }) => <div className="card" data-testid="explanation-card">{children}</div>;

export const ExplanationCard = ({ hit, play, positions }) => {
  if (!hit) {
    return (
      <Shell>
        <div className="flex items-center gap-3">
          <Hand className="shrink-0 text-[var(--accent)]" size={28} />
          <p className="text-base font-semibold" data-testid="explanation-text">Tap anywhere on the field to hit the ball.</p>
        </div>
      </Shell>
    );
  }
  if (hit.foul) return <Shell><p className="font-heading text-2xl font-bold uppercase" data-testid="explanation-text">Foul ball, runners return.</p></Shell>;
  if (!play) return <Shell>Loading play...</Shell>;
  const rows = Object.values(positions).sort((a, b) => ORDER.indexOf(roleOf(a.job)) - ORDER.indexOf(roleOf(b.job)));
  return (
    <div className="card space-y-4" data-testid="explanation-card">
      <div className="flex items-start justify-between gap-3">
        <p className="text-base sm:text-lg font-semibold leading-snug" data-testid="explanation-text">{play.explanation}</p>
        <PlayBadge play={play} />
      </div>
      {play.notes.map((n) => (
        <div key={n} className="note-callout" data-testid="play-note"><AlertTriangle size={20} className="shrink-0" /><span>{n}</span></div>
      ))}
      {play.coach_note && (
        <div className="coach-callout" data-testid="coach-note"><MessageSquareText size={20} className="shrink-0" /><span>{play.coach_note}</span></div>
      )}
      {play.staff_note && (
        <div className="staff-callout" data-testid="staff-note"><Lock size={18} className="shrink-0" /><span><b>Coaches only:</b> {play.staff_note}</span></div>
      )}
      <ul className="grid grid-cols-2 sm:grid-cols-3 gap-2" data-testid="assignment-list">
        {rows.map((p) => (
          <li key={p.pos} className="assign-row" data-testid={`assignment-${p.pos.toLowerCase()}`}>
            <span className="assign-dot" style={{ background: ROLE_COLORS[roleOf(p.job)] }}>{p.pos}</span>
            <span className="min-w-0">
              <span className="block truncate">{p.label}</span>
              {p.note && <span className="block text-xs font-medium text-[var(--muted)] leading-tight">{p.note}</span>}
            </span>
          </li>
        ))}
      </ul>
    </div>
  );
};
